import type { Gender } from "@/types/common"
import type { Fetus } from "@/types/pregnancy"
import { API_ROOT, HttpClient } from "@/api/httpClient"
import weights from "./weights"

export interface FetusPayload {
	name: string | null
	gender: Gender | null
	notes: string | null
}

export default {
	list(patientId: number, pregnancyId: number) {
		return HttpClient.get<Fetus[]>(`${API_ROOT}/patients/${patientId}/pregnancies/${pregnancyId}/fetuses`)
	},
	create(patientId: number, pregnancyId: number, payload: FetusPayload) {
		return HttpClient.post<Fetus>(`${API_ROOT}/patients/${patientId}/pregnancies/${pregnancyId}/fetuses`, payload)
	},
	update(patientId: number, pregnancyId: number, fetusId: number, payload: FetusPayload) {
		return HttpClient.put<Fetus>(
			`${API_ROOT}/patients/${patientId}/pregnancies/${pregnancyId}/fetuses/${fetusId}`,
			payload
		)
	},
	delete(patientId: number, pregnancyId: number, fetusId: number) {
		return HttpClient.delete(`${API_ROOT}/patients/${patientId}/pregnancies/${pregnancyId}/fetuses/${fetusId}`)
	},
	weights
}
